//#region src/isQuotaExceededError.ts
var isQuotaExceededError = (e) => {
	let quotaExceeded = false;
	if (e) {
		if (e.code) switch (e.code) {
			case 22:
				quotaExceeded = true;
				break;
			case 1014:
				if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
				break;
			default: break;
		}
		else if (e.number === -2147024882) quotaExceeded = true;
	}
	return quotaExceeded;
};
//#endregion
export { isQuotaExceededError };

//# sourceMappingURL=isQuotaExceededError.mjs.map